import React from 'react';
import { useTranslation } from 'react-i18next';
import {
	BsPencilFill,
	BsTrash3,
	BsThreeDotsVertical,
	BsXLg,
	BsFillGearFill,
} from 'react-icons/bs';
import { MdContentCopy } from 'react-icons/md';

import BayTooltip from '../BayTooltip';

interface ActionButtonProps {
	onClick?: () => void;
	isActive?: boolean;
	variant: 'edit' | 'delete' | 'menu' | 'duplicate' | 'setting';
	customTooltip?: string;
	translate?: any;
}

// Module scope: an in-body component is a new type every render, so wrapping
// each variant's <div> in it would remount that div (and its svg) on every ActionButton render.
const TooltipWrapper = ({
	children,
	customTooltip,
	tooltip,
}: { children: React.ReactElement; customTooltip?: string; tooltip: string }) => {
	return (
		<BayTooltip overlay={customTooltip ? customTooltip : tooltip}>
			{children}
		</BayTooltip>
	);
};

const ActionButton = ({
	onClick,
	isActive,
	variant,
	customTooltip,
	translate,
}: ActionButtonProps) => {
	const innerTranslate = useTranslation();
	const t = translate ? translate : innerTranslate.t;

	switch (variant) {
	case 'edit':
		return (
			<TooltipWrapper customTooltip={customTooltip} tooltip={isActive ? t('close') : t('edit')}>
				<div
					className={`bay-icon-editable ${isActive ? 'close' : 'edit'}`}
					onClick={onClick}
				>
					{isActive ? <BsXLg size={16} /> : <BsPencilFill size={16} />}
				</div>
			</TooltipWrapper>
		);
	case 'delete':
		return (
			<TooltipWrapper customTooltip={customTooltip} tooltip={t('delete')}>
				<div className="bay-icon-editable delete" onClick={onClick}>
					<BsTrash3 size={16} />
				</div>
			</TooltipWrapper>
		);
	case 'menu':
		return (
			<TooltipWrapper customTooltip={customTooltip} tooltip={t('actions')}>
				<div
					className={`bay-icon-editable menu ${isActive ? 'active' : ''}`}
					onClick={onClick}
				>
					<BsThreeDotsVertical size={16} />
				</div>
			</TooltipWrapper>
		);
	case 'duplicate':
		return (
			<TooltipWrapper customTooltip={customTooltip} tooltip={t('duplicate')}>
				<div className="bay-icon-editable duplicate" onClick={onClick}>
					<MdContentCopy size={16} />
				</div>
			</TooltipWrapper>
		);
	case 'setting':
		return (
			<TooltipWrapper customTooltip={customTooltip} tooltip={t('settings')}>
				<div className="bay-icon-editable settings" onClick={onClick}>
					<BsFillGearFill size={16} />
				</div>
			</TooltipWrapper>
		);
	}
};

export default ActionButton;
